// extracted by mini-css-extract-plugin
export default {"answer":"CheckQuestion_answer__cfCuo","question":"CheckQuestion_question__cwPvq","text":"CheckQuestion_text__abE3v"};